import { UUID } from "../generic/uuid";
import { PostalAddressModel } from "./postalAddress";
import { createVatTaxDtoFromAdminVatTaxModel, VatTaxModel } from "./vatTax";
import { SupplierModel } from "./supplier";
import { OrganisationStatusModel } from "./organisationStatus";
import { UserAccountModel } from "./userAccount";
import { ImageModel } from "./image";
import {
  createUserOrganisationDtoFromAdminUserOrganisationModel,
  UserOrganisationModel,
} from "./userOrganisation";
import { TimezoneEnum } from "@vini-wine/core-enums";
import { OrganisationDto } from "@vini-wine/core-dtos";
import { IntegrationExactModel } from "./integrationExact";
import { PermissionModel } from "./permission";
import { PlanModel } from "./plan";

export interface OrganisationModel extends UUID {
  // available includes
  suppliers?: Partial<SupplierModel>[];
  billingPostalAddress?: PostalAddressModel;
  defaultShippingPostalAddress?: PostalAddressModel | null;
  organisationOwner?: Partial<UserAccountModel>;
  registeredBy?: Partial<UserAccountModel>;
  userOrganisations?: UserOrganisationModel[];
  avatar?: ImageModel | null;
  integrationExact?: IntegrationExactModel | null;
  permissions?: PermissionModel[];
  defaultSalesContactUserOrganisation?: UserOrganisationModel;
  plan?: PlanModel;

  // transform
  name: string;
  legalName: string;
  vatTax: VatTaxModel;
  createdAt: Date;
  defaultTimezone: TimezoneEnum;
  status: OrganisationStatusModel;
  isVerified: boolean;
}

export const createOrganisationDtoFromAdminOrganisationModel = (
  organisation: OrganisationModel,
): OrganisationDto => {
  return {
    defaultTimezone: organisation.defaultTimezone,
    legalName: organisation.legalName,
    name: organisation.name,
    uuid: organisation.uuid,
    vatTax: createVatTaxDtoFromAdminVatTaxModel(organisation.vatTax),
    defaultSalesContactUserOrganisation:
      organisation.defaultSalesContactUserOrganisation
        ? createUserOrganisationDtoFromAdminUserOrganisationModel(
            organisation.defaultSalesContactUserOrganisation,
          )
        : undefined,
  };
};
